import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: ${props => props.background ?
        `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${props.background})` :
        props.backgroundColor || '#282E33'};
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    width: 90%;
    max-width: 480px;
    height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    overflow: hidden;

    @media (max-width: 768px) {
        width: 100%;
        height: 100%;
        border-radius: 0;
    }
`;

export const ModalInnerContent = styled.div`
    // background: rgba(40, 46, 51, 0.9);
    // backdrop-filter: blur(10px);
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ModalHeader = styled.div`
    padding: 16px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    h2 {
        margin: 0;
        color: ${props => props.textColor || '#fff'};
        font-size: 18px;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* Add a container for the icons */
    & > div {
        display: flex;
        flex-direction: row; /* Ensure horizontal layout */
        align-items: center;
        gap: 8px;
    }
`;


export const TodoList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 16px;
    overflow-y: auto;
    max-height: calc(90vh - 70px);

    @media (max-width: 768px) {
        max-height: 100%;
    }

    /* Webkit browsers (Chrome, Safari) */
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
        
        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const TodoItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background: ${props => props.isDragging ?
        'rgba(255, 255, 255, 0.1)' :
        'transparent'};
    border-radius: 4px;
    transition: background 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.05);
    }
`;

export const NewTodoItem = styled(TodoItem)`
    background: ${props => props.isFocused ?
        'rgba(255, 255, 255, 0.05)' :
        'transparent'};
`;

export const Checkbox = styled.input`
    margin: 0;
    width: 18px;
    height: 18px;
    border-radius: 2px;
    cursor: pointer;
    appearance: none;
    border: 2px solid ${props => props.textColor || 'rgba(255, 255, 255, 0.5)'};
    background: transparent;
    position: relative;

    &:checked {
        background: ${props => props.textColor || '#0079BF'};
        border-color: ${props => props.textColor || '#0079BF'};

        &:after {
            content: '✓';
            position: absolute;
            color: ${props => props.backgroundColor || 'white'};
            font-size: 12px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }
`;

export const TodoInput = styled.textarea`
    height: 24px;
    flex: 1;
    background: transparent;
    border: none;
    color: ${props => props.textColor || (props.completed ? 'rgba(255, 255, 255, 0.5)' : '#fff')};
    font-size: 14px;
    padding: 4px;
    text-decoration: ${props => props.completed ? 'line-through' : 'none'};
    resize: none;
    overflow-y: hidden;
    white-space: pre-wrap;

    &::placeholder {
        color: ${props => props.textColor ? props.textColor : 'rgba(255, 255, 255, 0.5)'};
        opacity: 0.5;
    }

    &:focus {
        outline: none;
    }
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: ${props => props.textColor || 'rgba(255, 255, 255, 0.7)'};
    font-size: 24px;
    cursor: pointer;
    padding: 0 8px;
    line-height: 1;

    &:hover {
        color: #fff;
    }
`;

export const DeleteButton = styled.button`
    background: none;
    border: none;
    color: ${props => props.textColor || 'rgba(255, 255, 255, 0.5)'};
    font-size: 18px;
    cursor: pointer;
    padding: 0 4px;
    opacity: 0;
    transition: opacity 0.2s ease;

    ${TodoItem}:hover & {
        opacity: 1;
    }

    &:hover {
        color: #FF5F5F;
    }
`;
